/**
 * Iter 145bt — Double Chance dedicated page (v3 teardown).
 */
import { useState } from "react";
import { ShieldCheck, CalendarRange, Layers } from "lucide-react";
import TopNav from "../components/TopNav";
import DoubleChanceBetslipPanel from "../components/DoubleChanceBetslipPanel";
import WeekBestPanel from "../components/WeekBestPanel";
import {
  V3Page, V3Container, V3Header, V3Eyebrow, V3Tabs,
} from "../components/v3";

export default function DoubleChancePage() {
  const [view, setView] = useState("daily");

  return (
    <V3Page testid="double-chance-page">
      <TopNav />
      <V3Container>
        <V3Header
          testid="double-chance-header"
          eyebrow={<V3Eyebrow icon={ShieldCheck}>Highest-converting market</V3Eyebrow>}
          title="Double chance."
          titleAccent="1X · X2 · 12 — the safest side."
          subtitle="The platform's most consistent market by hit-rate, refreshed daily with auto-graded outcomes."
        />

        <div className="mb-8">
          <V3Tabs
            value={view}
            onChange={setView}
            testidPrefix="double-chance-view"
            tabs={[
              { value: "daily",     label: "Daily 25",                icon: Layers,        testid: "double-chance-view-daily" },
              { value: "week-best", label: "Week's Best · Focus mode", icon: CalendarRange, testid: "double-chance-view-week-best" },
            ]}
          />
        </div>

        {view === "week-best" ? (
          <WeekBestPanel market="double-chance" />
        ) : (
          <DoubleChanceBetslipPanel />
        )}
      </V3Container>
    </V3Page>
  );
}
